import styled from "@emotion/styled/macro";
import React from "react";

import logoImg from "../res/img_BBH_logo.png";
import scanQrCodeIcon from "../res/i_qrcode.svg";
import Button from "../common/Button";

const Content = styled<"div", { showPlaceholder: boolean }>("div")`
  flex: 1 1;
  padding: 0 5vw;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const Logo = styled("img")`
  width: 100%;
`;

const BodyText = styled("p")`
  width: 260px;
  margin: 0 auto;
`;

const ScanQRCodeButton = styled(Button)`
  height: 80px;
`;

const Title = styled("h5")`
  font-weight: normal;
  text-transform: uppercase;
  width: 260px;
  margin: 0 auto;
  font-size: 18px;
`;

const ContactInfo = styled("div")`
  width: 260px;
  margin: 0 auto;
  p {
    margin: 0.25em auto;
  }
`;

interface IProps {
  showPlaceholder?: boolean;
}

export default function NoBobbleContent({ showPlaceholder = false }: IProps) {
  return (
    <Content showPlaceholder={showPlaceholder}>
      {showPlaceholder && <Title>Introducing</Title>}
      <Logo src={logoImg} />
      <BodyText>
        All of the good parts of a traditional bobblehead doll giveaway, with
        none of the bad parts
      </BodyText>
      {showPlaceholder ? (
        <ContactInfo>
          <p>Contact:</p>
          <p>
            <strong>Seth Rabinowitz</strong>
          </p>
          <p>Founder &amp; President</p>
          <p>+1 917-723-7073</p>
          <p>Seth@BetterBobblehead.com</p>
        </ContactInfo>
      ) : (
        <ScanQRCodeButton iconUrl={scanQrCodeIcon}>
          Scan QR Code
        </ScanQRCodeButton>
      )}
    </Content>
  );
}
